export const FETCH_ALL = "FETCH_ALL";
export const FAVORITE = "FAVORITE";

export const AUTHENTICATE = "AUTHENTICATE";
export const LOGOUT = "LOGOUT";
